<template>
  <div class="service-order">
    <div class="service-order-top">
      <div>服务记录</div>
      <p>查看提交的服务记录</p>
    </div>
    <div v-if="show">
      <div class="service-record-input">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-row :gutter="24">
            <!-- <el-col :span="6">
              <el-form-item label="服务编号">
                <el-input
                  v-model="ruleForm.orderNo"
                  size="mini"
                ></el-input> </el-form-item
            ></el-col> -->
            <el-col :span="6">
              <el-form-item label="项目名称">
                <el-select
                  v-model="ruleForm.productId"
                  placeholder="请选择"
                  size="mini"
                  style="width: 100%"
                  filterable
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.productName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="服务分类">
                <el-cascader
                  size="mini"
                  :props="{ value: 'id',label: 'name',children: 'children' }"
                  v-model="serviceType"
                  :options="serverOptions">
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理状态">
                <el-select
                  v-model="ruleForm.status"
                  placeholder="请选择"
                  size="mini"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in statuslist"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button @click="submit" size="small" class="theme-btn" type="primary">搜索</el-button>
                <el-button @click="clean" size="small">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="service-record-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style="{ background: '#eff3f8', color: '#333' }"
          size="small"
          v-loading="loading"
        >
          <el-table-column
            fixed
            prop="orderNo"
            label="服务编号"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="problemDescription"
            label="问题描述"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="productName"
            label="项目名称"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="labelName"
            label="服务分类"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="submitTime"
            label="提交时间"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="statusName"
            label="处理状态"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="level"
            label="客户等级"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.level == 'Y' ? 'VIP用户' : '常规用户' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <!-- <el-button
            
              >修改</el-button
            > -->
              <i
                class="el-icon-edit-outline"
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.status == 0"
                style="color: #2177ce; margin-right: 15px; cursor: pointer"
              ></i>
              <el-popconfirm title="确定删除吗?" @confirm="deletes(scope.row)" v-if="scope.row.status == 0">
                <i
                  slot="reference"
                  class="el-icon-delete"
                  type="text"
                  size="small"
                  style="color: #fc4343; cursor: pointer"
                ></i>
              </el-popconfirm>
              <el-button
                type="text"
                size="small"
                v-if="scope.row.status == 2"
                @click="score(scope.row, true)"
                >请评分</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="scope.row.evaluateStar"
                @click="clickLook(scope.row, false)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="service-record--pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="queryParam.total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <modify v-else ref="modifyRef" @showing="showing" />
    <div class="service-record--dialog">
      <el-dialog title="评分" :visible.sync="dialogVisible" width="40%">
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          style="text-align: left"
        >
          <el-form-item
            label="评分:"
            style="display: flex; align-items: center"
            class="service-dialog-star"
          >
            <el-rate
              v-model="form.evaluateStar"
              :disabled="!scoretype"
            ></el-rate>
          </el-form-item>
          <el-form-item label="意见:">
            <el-input
              :disabled="!scoretype"
              type="textarea"
              v-model="form.evaluateContent"
              size="small"
              placeholder="请输入意见"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="determine"
            size="small"
            v-if="scoretype"
            >确 定</el-button
          >
          <el-button @click="cancellation" size="small">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/service.scss`
)
import modify from './modify.vue'
export default {
  components: { modify },
  data() {
    return {
      scoretype: true,
      form: {},
      dialogVisible: false,
      queryParam: {
        page: 1,
        pageSize: 5,
        total: 0,
      },
      options: [],
      ruleForm: {},
      typelist: [],
      statuslist: [],
      tableData: [],
      modifys: {},
      objlist: {},
      loading: false,
      serverOptions: [],
      serviceType: [],
      show: true
    }
  },
  computed: {
    token() {
      return this.$store.state.login.token
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.show = false
    } else {
      this.show = true
    }
    this.getListAll()
    this.getType()
    this.getlists()
    this.getTreeData()
  },

  methods: {
    getTreeData() {
      this.$api.suppage.gettreeData(2).then((res) => {
        if (res.code === 200) {
          this.serverOptions = res.data
        }
      })
    },
    clickLook(val, type) {
      this.dialogVisible = true
      this.$set(this.form, 'evaluateStar', val.evaluateStar)
      this.$set(this.form, 'evaluateContent', val.evaluateContent)
      this.scoretype = type
    },
    cancellation() {
      this.form = Object.assign({}, {})
      this.dialogVisible = false
    },
    determine() {
      if (!this.form.evaluateStar) {
        return this.$message.error('请评分！')
      }
      if (!this.form.evaluateContent) {
        this.form.evaluateContent = ''
      }
      let obj = {
        id: this.objlist.id,
        evaluateContent: this.form.evaluateContent,
        evaluateStar: this.form.evaluateStar,
      }
      this.$api.suppage.putWorkOrder(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.getlists()
        }
      })
    },
    score(val, type) {
      this.objlist = val
      this.dialogVisible = true
      this.scoretype = type
    },
    deletes(item) {
      this.$api.suppage.DELETEWorkOrder(item.id)
      this.getlists()
    },
    showing() {
      this.getlists()
    },
    handleClick(item) {
      this.$router.push(`/support/service?type=3&id=${item.id}`)
      // this.$refs.modifyRef.showdialogVisible(item)
    },
    getlists() {
      this.loading = true
      const params = {
        orderNo: this.ruleForm.orderNo,
        productId: this.ruleForm.productId,
        pageNum: this.queryParam.page,
        pageSize: this.queryParam.pageSize,
        label: this.serviceType[1],
        status: this.ruleForm.status,
      }
      this.$api.suppage.getlists(params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.rows
          this.queryParam.total = res.total
          console.log(this.queryParam.total)
          this.loading = false
        }
      })
    },
    currentChange(v) {
      console.log(v, 'ssssssss')
      this.queryParam.page = v
      this.getlists()
    },
    submit() {
      this.queryParam.page = 1
      this.getlists()
    },
    clean() {
      this.queryParam.page = 1
      this.ruleForm = Object.assign({}, {})
      this.serviceType = []
      this.getlists()
    },
    getType() {
      // this.$api.suppage.getType('dict_question_label').then((res) => {
      //   this.typelist = res.data
      // })
      this.$api.suppage.getType('dict_work_status').then((res) => {
        this.statuslist = res.data
      })
    },
    getListAll() {
      this.$api.suppage.getListAll().then((res) => {
        this.options = res.data
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
